/* eslint-disable import/first */
// The localStorage polyfill below must run before importing modules whose
// top-level code may touch localStorage (e.g. authenticatedAxiosInstance).
// './polyfills' alone wasn't sufficient — keeping the inline block here.
import './polyfills';

if (typeof window !== 'undefined' && typeof window.localStorage === 'undefined') {
  const localStoragePolyfill = {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {},
    clear: () => {},
    key: () => null,
    length: 0,
  };
  Object.defineProperty(window, 'localStorage', {
    value: localStoragePolyfill,
    writable: true,
  });
}

import React from 'react';
import './index.scss';
import { AppProviders } from './contexts';
import App from './App';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import './services/authenticatedAxiosInstance.service';
import { initializeAppInsights } from './services/applicationInsights.service';
import ChunkErrorBoundary from './components/Common/ChunkErrorBoundary';

// Initialize Application Insights before rendering the app
initializeAppInsights();

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const container = document.createElement('div');
document.body.appendChild(container);
const root = createRoot(container);

root.render(
  <ChunkErrorBoundary>
    <AppProviders>
      <App />
    </AppProviders>
  </ChunkErrorBoundary>
);
